import AxiosClient from '@/repositories/clients/axiosCsExternal'

const resource = '/leads'

const findOne = async (leadIdOrDocument, queryParams = '', organization) => {
  try {
    const response = await AxiosClient.get(
      `${resource}/${leadIdOrDocument}?${queryParams}`, { headers: { organization } }
    )
    return response
  } catch (error) {
    return error
  }
}

const requestAccess = async (email, organization) => {
  const result = await AxiosClient.get(`${resource}/requestAccess?email=${email}&type=lead`, { headers: { organization } })
  return result
}

export {
  requestAccess,
  findOne
}
